module.exports = __webpack_public_path__ + "media/images/element/coding-c6960bac2aa1a63ec5252bb6631226cc.svg";